import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";
import { TransferPage } from "./pages/TransferPage";
import { transferRoutes } from "./data/transferRoutes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/lisbon-airport-to-sintra-transfer" element={<TransferPage data={transferRoutes.sintra} />} />
          <Route path="/lisbon-airport-to-cascais-transfer" element={<TransferPage data={transferRoutes.cascais} />} />
          <Route path="/lisbon-to-algarve-transfer" element={<TransferPage data={transferRoutes.algarve} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
